'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _doctify = require('../../src/img/doctify.png');

var _doctify2 = _interopRequireDefault(_doctify);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = typeof navigator !== 'undefined' && navigator.languages || ['en'],
    locale = _ref[0];
// import { bindActionCreators } from 'redux';


var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
  messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
  messages = require('../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var profileTypes = ['practice', 'specialist'];

/**
 * Returns true if the query has a valid profile, that is, it has a profile type
 * of "practice" or "specialist", and has a profile ID.
 * @param {!Object} query The URL query.
 * @return {boolean} True if the query has a valid profile.
 */
var isValidProfile = function isValidProfile(query) {
  return query && query.profileType && profileTypes.includes(query.profileType) && query.profileId;
};

/**
 * Returns the URL that opens on button click. This is will be the Doctify home
 * page if the query doesn't have a valid profile, or a practice or specialist
 * page otherwise.
 * @param {!Object} query The URL query.
 * @return {string} The URL to open on button click.
 */
var getUrl = function getUrl(query) {
  return 'https://www.doctify.com/uk' + (isValidProfile(query) && '/' + query.profileType + '/' + query.profileId || '');
};

/**
 * Returns the hashed string of the class to use to style the button. There is
 * a light and a dark theme, and the light theme is used by default.
 * @param {!Object} query The URL query.
 * @return {string} The class to use to style the button.
 */
var getThemeClass = function getThemeClass(query) {
  return query && query.theme && _style2.default[query.theme] || _style2.default.light;
};

var _ref2 = _react2.default.createElement('img', { src: _doctify2.default });

var BookButtonWidget = function BookButtonWidget(props) {
  return _react2.default.createElement(
    _reactIntl.IntlProvider,
    { locale: localeBase, messages: messages },
    _react2.default.createElement(
      'div',
      { className: _style2.default.bookButton + ' ' + props.className },
      _react2.default.createElement(
        'a',
        {
          className: getThemeClass(props.location && props.location.query),
          href: getUrl(props.location && props.location.query),
          target: '_blank',
          rel: 'nofollow noopener'
        },
        _ref2,
        _react2.default.createElement(
          'div',
          { className: _style2.default.text },
          'Book with Doctify'
        )
      )
    )
  );
};

BookButtonWidget.propTypes = {
  profileType: require('react').PropTypes.string,
  profileId: require('react').PropTypes.string,
  theme: require('react').PropTypes.string,
  location: require('react').PropTypes.object,
  className: require('react').PropTypes.string,
  onClick: require('react').PropTypes.func.isRequired
};
BookButtonWidget.displayName = 'BookButtonWidget';

BookButtonWidget.defaultProps = {};

exports.default = BookButtonWidget;
